import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, ButtonVariant } from '@amzn/atoz-web/Button';
export var SwapPageFooterContinueButton = function (_a) {
    var onClick = _a.onClick, buttonId = _a.buttonId;
    var t = useTranslation().t;
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { type: "button", onClick: onClick, variant: ButtonVariant.Primary, dataTestId: "SwapFooterContinue", id: buttonId, key: "SwapFooterContinueButton" }, t('shift_management_features_SwapPageFooter_continue'))));
};
